<div class="header-navigation-back">
    <mat-icon (click)="onNavigateToProfile()">arrow_back</mat-icon>
    <span fxFlex class="title">Driver Abstract</span>
</div>
<div fxLayout="column" fxLayoutAlign="center stretch">
    <div fxFlex fxLayout="column" class="padding-sides-2x">
        <p *ngIf="!driverAbstract">
            <b>We are yet to
                recieve/process your Driver Abstract Document.</b></p>
        <p *ngIf="driverAbstract">
            Your Driver Abstract
            document
            was uploaded to our system on {{driverAbstract.createdDate|date: 'dd/MM/yyyy'}}.</p>
        <p>If you need further assistance, please get in touch with one of our support
            group at <u>support@FleetOperate.com</u>.</p>
    </div>
</div>